// pathname: /v1/user-unlock-view/${slug}
// ****************************************************************************************************
import { ApiResumeDetail, useSwrMutationApi } from '@hooks/useSwrApi';
import { SwrToastsProps } from '@type/swr';

interface SwrUnlockViewProps {
  slug: string;
  locale: string,
  successCallback?: (response: ApiResumeDetail) => void,
  errorCallback?: (errors?: ApiSchema<'ErrorResponse'>) => void,
  toastsOptions?: SwrToastsProps,
}

/**
 * @description SWR mutation: Unlock CV view with 1 neuro
 * ** Path params **
 * - `slug`: The user slug.
 *
 * ** Props **
 * - `locale`: The locale to use for the request.
 * - `successCallback`: The callback function to call on success.
 * - `errorCallback`: The callback function to call on error.
 * - `toastsOptions`: The SWR toasts options.
 */
export const useSwrUserUnlockView = (props: SwrUnlockViewProps) => {
  // Props destructuring
  // ********************************************
  const {
    slug,
    locale,
    successCallback,
    errorCallback,
    toastsOptions,
  } = props;

  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<ApiResumeDetail, undefined>({
    url: `/v2/user-unlock-view/${slug}`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: (response) => {
        // Callback
        if (successCallback) successCallback(response);
      },
      onError: (errors) => {
        // Callback
        if (errorCallback) errorCallback(errors);
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
      ...toastsOptions,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};

